export const MARKER_OBJECT = {
  "1": "tent",
  "2": "shelter",
  "3": "bnb",
  "4": "hostel",
  "5": "hostel",
  "6": "apartment",
  "7": "camp",
  "8": "camper",
  "9": "inn",
  "10": "farm",
  "11": "markerFallback",
  "12": "restroom",
  "13": "water",
  "14": "bench",
  "15": "madpakkehus",
  "16": "fire",
  "17": "pump",
  "18": "parking",
  "19": "fire",
  "20": "pharmacy",
  "21": "cafe",
  "22": "restaurant",
  "23": "local",
  "24": "church",
  "25": "museum",
  "26": "ruin",
  "27": "castle",
  "28": "shop",
  "29": "stemp",
  "30": "sculpture",
  "31": "park",
  "32": "architecture",
  "33": "markerFallback",
  "34": "markerFallback",
  "35": "markerFallback",
} as const;

export const MARKER_POPUP_OBJECT = {
  "1": "tentWhite",
  "2": "shelterWhite",
  "3": "bnbWhite",
  "4": "hostelWhite",
  "5": "hostelWhite",
  "6": "apartmentWhite",
  "7": "campWhite",
  "8": "camperWhite",
  "9": "innWhite",
  "10": "farmWhite",
  "11": "markerFallbackWhite",
  "12": "restroomWhite",
  "13": "waterWhite",
  "14": "benchWhite",
  "15": "madpakkehusWhite",
  "16": "fireWhite",
  "17": "pumpWhite",
  "18": "parkingWhite",
  "19": "fireWhite",
  "20": "pharmacyWhite",
  "21": "cafeWhite",
  "22": "restaurantWhite",
  "23": "localWhite",
  "24": "churchWhite",
  "25": "museumWhite",
  "26": "ruinWhite",
  "27": "castleWhite",
  "28": "shopWhite",
  "29": "markerFallbackWhite",
  "30": "sculptureWhite",
  "31": "parkWhite",
  "32": "architectureWhite",
  "33": "markerFallbackWhite",
  "34": "markerFallbackWhite",
  "35": "markerFallbackWhite",
} as const;

export const ROUNDED_ICONS_IDS = [
  "32",
  "31",
  "30",
  "27",
  "26",
  "25",
  "24",
  "23",
  "22",
  "21",
  "21",
];

export const internallID = [
  { id: "1", geoFaIds: ["3031"], guideDenmarkIds: [] }, //Tent sites
  { id: "2", geoFaIds: ["3012"], guideDenmarkIds: ["31"] }, //Shelter sites
  { id: "3", guideDenmarkIds: ["22"], geoFaIds: [] }, // Bed & Breakfast
  { id: "4", guideDenmarkIds: ["27"], geoFaIds: [] }, // Hotels
  { id: "5", guideDenmarkIds: ["35"], geoFaIds: [] }, // Hostels
  { id: "6", guideDenmarkIds: ["32"], geoFaIds: [] }, // Holiday apartments
  { id: "7", guideDenmarkIds: ["28"], geoFaIds: [] }, // Inns
  { id: "8", guideDenmarkIds: ["24"], geoFaIds: [] }, // Campsites
  { id: "9", guideDenmarkIds: ["30"], geoFaIds: [] }, // Camp schools
  { id: "10", guideDenmarkIds: ["23"], geoFaIds: [] }, // Farm holidays
  { id: "11", guideDenmarkIds: ["29"], geoFaIds: [] }, // Unconventional accommodation
  { id: "12", geoFaIds: ["1012"], guideDenmarkIds: ["77"] }, //Toilets
  { id: "13", geoFaIds: ["1222"], guideDenmarkIds: [] }, //Water posts
  { id: "14", geoFaIds: ["1201"], guideDenmarkIds: [] }, // Tables and benches
  { id: "15", geoFaIds: ["1132", "3091"], guideDenmarkIds: [] }, //Rest areas
  { id: "17", geoFaIds: ["1112"], guideDenmarkIds: [] }, // Bicycle pump stations
  { id: "18", geoFaIds: ["1351"], guideDenmarkIds: ["73"] }, //Parking lots
  { id: "19", geoFaIds: ["1022"], guideDenmarkIds: [] }, //Campfire sites
  { id: "20", guideDenmarkIds: ["81"], geoFaIds: [] }, //Pharmacists
  { id: "21", guideDenmarkIds: ["64"], geoFaIds: [] }, // Cafee
  { id: "22", guideDenmarkIds: ["63"], geoFaIds: [] }, //Restaurants
  { id: "23", guideDenmarkIds: ["65"], geoFaIds: [] }, // Local
  { id: "24", guideDenmarkIds: ["8"], geoFaIds: [] }, //Churches and monasteries
  { id: "25", guideDenmarkIds: ["13", "6"], geoFaIds: [] }, //Museums
  { id: "26", guideDenmarkIds: ["15"], geoFaIds: [] }, //Monuments and ruins
  { id: "27", guideDenmarkIds: ["16"], geoFaIds: [] }, //Castles and manors
  { id: "28", guideDenmarkIds: ["47"], geoFaIds: [] }, //Grocery shopping
  // Haervejen passports
  { id: "29", guideDenmarkIds: [], geoFaIds: [] }, //Hærvejspas
  //new
  { id: "30", guideDenmarkIds: ["12"], geoFaIds: [] }, //Street Art and Sculptures
  { id: "31", guideDenmarkIds: ["7", "14"], geoFaIds: [] }, //Parks and gardens
  { id: "32", guideDenmarkIds: ["4"], geoFaIds: [] }, //Architecture and Urban Spaces
  { id: "33", guideDenmarkIds: ["49"], geoFaIds: [] }, //Beaches and outdoor pools
  { id: "34", guideDenmarkIds: ["42", "46"], geoFaIds: [] }, //Fishing
  { id: "35", guideDenmarkIds: ["76"], geoFaIds: [] }, //Turist information
];
